import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowUp } from "lucide-react";
import { LogoMark } from "@/components/LogoMark";
import { scrollToId } from "@/lib/scroll";

const SECRET = "rare";

export const Footer = () => {
    const navigate = useNavigate();
    const [unlocked, setUnlocked] = useState(false);

    useEffect(() => {
        let buffer = "";
        const onKey = (e) => {
            const tag = document.activeElement?.tagName;
            if (tag === "INPUT" || tag === "TEXTAREA") return;
            if (e.key.length !== 1 || !/[a-z]/i.test(e.key)) return;
            buffer = (buffer + e.key.toLowerCase()).slice(-SECRET.length);
            if (buffer === SECRET) setUnlocked(true);
        };
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, []);

    return (
        <footer
            data-testid="footer"
            className="flex flex-col gap-6 border-t border-white/10 px-6 py-10 md:flex-row md:items-center md:justify-between md:px-12"
        >
            <p className="font-display text-lg font-black tracking-tight text-white">
                RaRe<span className="align-super text-[0.5em] text-white/40">®</span>
            </p>

            <div className="flex items-center gap-6">
                <p className="font-mono-x text-[11px] uppercase tracking-[0.2em] text-zinc-500">
                    Idea in. Business out. — © 2026
                </p>
                <AnimatePresence>
                    {unlocked && (
                        <motion.button
                            data-testid="footer-pitch-button"
                            onClick={() => navigate("/pitch")}
                            initial={{ opacity: 0, y: 8, filter: "blur(6px)" }}
                            animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                            exit={{ opacity: 0, y: 8 }}
                            transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
                            className="group inline-flex items-center gap-2 rounded-full border border-white/15 px-4 py-2 font-mono-x text-[10px] uppercase tracking-[0.2em] text-zinc-300 transition-colors duration-300 hover:border-white/50 hover:text-white"
                        >
                            <LogoMark
                                size={12}
                                className="text-white transition-transform duration-500 group-hover:rotate-90"
                            />
                            The Pitch
                        </motion.button>
                    )}
                </AnimatePresence>
            </div>

            <button
                data-testid="footer-back-to-top"
                onClick={() => scrollToId("#top")}
                aria-label="Back to top"
                className="group grid h-11 w-11 place-items-center rounded-full border border-white/15 text-zinc-400 transition-colors duration-300 hover:border-white/50 hover:text-white"
            >
                <ArrowUp className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5" />
            </button>
        </footer>
    );
};
